import styled from 'styled-components';

export const Content = styled.div`
  height: 620px;
  width: 100%;
  display: flex;
`;
